<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="surrForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.fencedUp"
                v-model="surrForm.fencedUp"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.securGrd"
                v-model="surrForm.securGrd"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.onSlope"
                v-model="surrForm.onSlope"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.retStrc"
                v-model="surrForm.retStrc"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.river"
                v-model="surrForm.river"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.floodProne"
                v-model="surrForm.floodProne"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.surrRemarks }}</v-subheader>
              <div class="queryValue">{{ surrForm.surrRemarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="surrForm.surrRemarks"
                :label="labels.surrRemarks"
                :error-messages="errors.collect('surrForm.surrRemarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="surrForm.surrRemarks"
                :data-vv-as="surrForm.surrRemarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        fencedUp: 'Is the building fenced-up?',
        securGrd: 'Is there any security guard / watchmen?',
        onSlope: 'Is the risk situated on / near a steep slope?',
        retStrc: 'Is there any earth retaining structure?',
        river: 'Is there any monsoon drain / river nearby?',
        floodProne: 'Is the locality flodd-proned / low-lying?',
        surrRemarks: 'Surroundings Comments'
      },
      surrForm: {
        survNo: undefined,
        verCnt: undefined,
        fencedUp: false,
        securGrd: false,
        onSlope: false,
        retStrc: false,
        river: false,
        floodProne: false,
        surrRemarks: undefined,
        survDetType: 'surroundings'
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      loading: false,
      showErrorDialog: false,
      submitting: false
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    }
  },
  methods: {
    async doInit() {
      this.surrForm.survNo = this.riskSurveyMaster.survNo
      this.surrForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    async loadInit() {
      this.surrForm.fencedUp = this.riskSurveyDetails.fencedUp
      this.surrForm.securGrd = this.riskSurveyDetails.securGrd
      this.surrForm.onSlope = this.riskSurveyDetails.onSlope
      this.surrForm.retStrc = this.riskSurveyDetails.retStrc
      this.surrForm.river = this.riskSurveyDetails.river
      this.surrForm.floodProne = this.riskSurveyDetails.floodProne
      this.surrForm.surrRemarks = this.riskSurveyDetails.surrRemarks
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doReset() {
      this.surrForm.fencedUp = false
      this.surrForm.securGrd = false
      this.surrForm.onSlope = false
      this.surrForm.retStrc = false
      this.surrForm.river = false
      this.surrForm.floodProne = false
      this.surrForm.surrRemarks = undefined
    }
  },
  created() {},
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {}
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
